@let days = expirationDays();
<div>You have an API key expiring in {{days}} {{days === 1 ? 'day' : 'days'}}.</div>
<div><app-button type="manage" label="Manage Keys" (clicked)="manageKeys()"/></div>
